<div class="items-simple-grid">
  <div class="items-simple-header">
    <span>Ubicación *</span>
    <span>Formato *</span>
    <span>Desde *</span>
    <span>Hasta *</span>
    <span>Días</span>
    <span>Cantidad</span>
    <span>Bonificado</span>
    <span class="header-right">Subtotal</span>
    <span class="header-right">Override</span>
    <span>Acciones</span>
  </div>

  <div
    *ngFor="let item of items(); trackBy: trackByRowId"
    class="items-simple-row item-row"
    [class.is-draft]="facade.isDraftRow(item.group, 'WEB_BANNER', item.index)"
    [class.is-loading]="facade.isRowLoading(item.index)"
    [class.is-invalid]="facade.isRowInvalid(item.group, 'WEB_BANNER')"
    [attr.data-item-index]="item.index"
    [formGroup]="item.group"
    (keydown)="handleRowKeydown($event, item.index)">
    @if (facade.isDraftRow(item.group, 'WEB_BANNER', item.index)) {
      <span class="draft-label">Nueva fila</span>
    }

    <div class="item-cell">
      <p-autoComplete
        [inputId]="'web-item-ubicacion-' + item.index"
        formControlName="ubicacionDigital"
        [suggestions]="facade.ubicacionDigitalSuggestions()"
        (completeMethod)="facade.searchUbicacionesDigitales($event.query || '', item.group, item.index)"
        placeholder="Ubicación"
        [dropdown]="true"
        [forceSelection]="true"
        [appendTo]="'body'"
        optionLabel="displayName"
        field="displayName"
        class="w-full"
        (keydown.enter)="handleEnterAdvance($event, item.group, 'ubicacionDigital')">
        <ng-template pTemplate="empty">
          <div class="lookup-empty">
            <span>Sin resultados.</span>
            @if (facade.hasLookupError('ubicacionDigital')) {
              <button type="button" class="lookup-retry" (click)="facade.retryLookup('ubicacionDigital', item.group, item.index)">
                Reintentar
              </button>
            }
          </div>
        </ng-template>
      </p-autoComplete>
      <app-field-error [control]="item.group.get('ubicacionDigital')" label="Ubicación"></app-field-error>
    </div>

    <div class="item-cell">
      <p-autoComplete
        formControlName="formatoDigital"
        [suggestions]="facade.formatoDigitalSuggestions()"
        (completeMethod)="facade.searchFormatosDigitales($event.query || '', item.group, item.index)"
        placeholder="Formato"
        [dropdown]="true"
        [forceSelection]="true"
        [appendTo]="'body'"
        optionLabel="displayName"
        field="displayName"
        class="w-full"
        (keydown.enter)="handleEnterAdvance($event, item.group, 'formatoDigital')">
        <ng-template pTemplate="empty">
          <div class="lookup-empty">
            <span>Sin resultados.</span>
            @if (facade.hasLookupError('formatoDigital')) {
              <button type="button" class="lookup-retry" (click)="facade.retryLookup('formatoDigital', item.group, item.index)">
                Reintentar
              </button>
            }
          </div>
        </ng-template>
      </p-autoComplete>
      <app-field-error [control]="item.group.get('formatoDigital')" label="Formato"></app-field-error>
    </div>

    <div class="item-cell">
      <p-datepicker
        formControlName="fechaDesde"
        dateFormat="dd/mm/yy"
        [appendTo]="'body'"
        class="w-full"
        (keydown.enter)="handleEnterAdvance($event, item.group, 'fechaDesde')">
      </p-datepicker>
      <app-field-error [control]="item.group.get('fechaDesde')" label="Fecha desde"></app-field-error>
    </div>

    <div class="item-cell">
      <p-datepicker
        formControlName="fechaHasta"
        dateFormat="dd/mm/yy"
        [appendTo]="'body'"
        class="w-full"
        (keydown.enter)="handleEnterAdvance($event, item.group, 'fechaHasta')">
      </p-datepicker>
      <app-field-error [control]="item.group.get('fechaHasta')" label="Fecha hasta"></app-field-error>
    </div>

    <div class="item-cell">
      <span class="font-semibold">
        {{ facade.calculateDias(item.group, vigenciaDesde, vigenciaHasta) }}
      </span>
    </div>

    <div class="item-cell">
      <p-inputNumber
        formControlName="cantidad"
        [min]="1"
        [maxFractionDigits]="0"
        class="w-full"
        (keydown.enter)="handleEnterAdvance($event, item.group, 'cantidad')"
        [disabled]="readOnly">
      </p-inputNumber>
      <app-field-error [control]="item.group.get('cantidad')" label="Cantidad"></app-field-error>
    </div>

    <div class="item-cell">
      <p-select
        formControlName="bonificado"
        [options]="bonificadoOptions"
        optionLabel="label"
        optionValue="value"
        [appendTo]="'body'"
        class="w-full"
        (keydown.enter)="handleEnterAdvance($event, item.group, 'bonificado')"
        [disabled]="readOnly">
      </p-select>
    </div>

    <div class="item-cell subtotal-cell">
      <span class="subtotal-value">
        {{ facade.getSubtotal(item.group) | currencyFormat:'$':2:true }}
      </span>
      @if (item.group.get('subtotalManual')?.value !== null && item.group.get('subtotalManual')?.value !== undefined && item.group.get('subtotalManual')?.value !== '') {
        <span class="manual-pill">Manual</span>
      }
    </div>

    <div class="item-cell override-cell">
      <p-inputNumber
        formControlName="subtotalManual"
        [min]="0"
        mode="decimal"
        [maxFractionDigits]="2"
        [disabled]="readOnly"
        styleClass="override-input"
        inputStyleClass="text-right"
        placeholder="Override">
      </p-inputNumber>
    </div>

    <div class="item-cell actions-cell">
      <button
        pButton
        type="button"
        icon="pi pi-refresh"
        class="p-button-text p-button-sm"
        pTooltip="Restaurar calculado"
        tooltipPosition="top"
        (click)="resetManualSubtotal(item.group)"
        [disabled]="readOnly || item.group.get('subtotalManual')?.value === null || item.group.get('subtotalManual')?.value === undefined || item.group.get('subtotalManual')?.value === ''">
      </button>
      <button
        pButton
        type="button"
        icon="pi pi-info-circle"
        class="p-button-text p-button-sm"
        pTooltip="Ver detalle de cálculo"
        tooltipPosition="top"
        (click)="openPricingDetail(item.group)"
        (keydown.enter)="openPricingDetail(item.group)"
        (keydown.space)="openPricingDetail(item.group); $event.preventDefault()">
      </button>
      <button
        pButton
        type="button"
        icon="pi pi-trash"
        class="p-button-rounded p-button-text p-button-danger p-button-sm"
        pTooltip="Eliminar ítem"
        tooltipPosition="top"
        (click)="confirmRemove(item.group, item.index)"
        [disabled]="readOnly">
      </button>
    </div>
  </div>

  <div *ngIf="items().length === 0" class="empty-state">
    No hay ítems cargados.
  </div>
</div>

<p-dialog
  [(visible)]="pricingDialogVisible"
  [modal]="false"
  [dismissableMask]="true"
  [closable]="true"
  [closeOnEscape]="true"
  [style]="{ width: '450px' }"
  header="Detalle de cálculo">
  @if (selectedTrace) {
    <div class="text-sm text-gray-900 dark:text-gray-100">
      <!-- RESUMEN RÁPIDO -->
      <div class="mb-4 p-3 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 rounded-lg border border-green-200 dark:border-green-700/50">
        <div class="flex items-center justify-between mb-2">
          <span class="text-xs font-semibold text-green-800 dark:text-green-200 uppercase tracking-wide">Resumen</span>
          <span [class]="{
            'px-2 py-0.5 rounded-full text-xs font-medium': true,
            'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100': selectedTrace.status === 'MATCHED',
            'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100': selectedTrace.status === 'NO_MATCH',
            'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100': selectedTrace.status === 'INCOMPLETE',
            'bg-orange-100 text-orange-800 dark:bg-orange-800 dark:text-orange-100': selectedTrace.status === 'BONIFICADO'
          }">
            {{ selectedTrace.status === 'MATCHED' ? 'OK' : selectedTrace.status === 'NO_MATCH' ? 'Sin tarifa' : selectedTrace.status === 'BONIFICADO' ? 'Bonificado' : 'Incompleto' }}
          </span>
        </div>
        <div class="grid grid-cols-2 gap-2 text-xs">
          <div>
            <span class="text-green-700 dark:text-green-300">Subtotal calculado:</span>
            <div class="font-bold text-lg text-green-900 dark:text-green-100">
              $ {{ (selectedTrace.calculation?.subtotalPreview ?? 0) | number:'1.2-2' }}
            </div>
          </div>
          @if (selectedTrace.match?.selectedDetalle) {
            <div>
              <span class="text-green-700 dark:text-green-300">Tarifa aplicada:</span>
              <div class="font-medium text-green-900 dark:text-green-100">
                {{ selectedTrace.match.selectedDetalle.unidadTarifacion || '-' }}
                @ {{ selectedTrace.match.selectedDetalle.precioUnitario ?? 0 | number:'1.2-2' }}
              </div>
            </div>
          }
        </div>
        @if (selectedTrace.calculation?.formula) {
          <div class="mt-2 pt-2 border-t border-green-200 dark:border-green-700/50">
            <span class="text-xs text-green-700 dark:text-green-300">Fórmula:</span>
            <div class="font-mono text-xs text-green-900 dark:text-green-100">{{ selectedTrace.calculation.formula }}</div>
          </div>
        }
      </div>

      <div class="text-xs text-gray-600 dark:text-gray-400 mb-3">
        <div class="font-semibold text-gray-900 dark:text-gray-100">Tarifa:</div>
        <div>{{ selectedTrace.tarifa?.codigo || '-' }} {{ selectedTrace.tarifa?.nombre || '' }}</div>
      </div>
      
      <!-- Tarifa Detalle Seleccionada -->
      @if (selectedTrace.match.selectedDetalle) {
        <div class="mb-3 p-2 bg-blue-50 dark:bg-blue-900/30 rounded border border-blue-200 dark:border-blue-700/50">
          <div class="text-xs font-semibold text-blue-900 dark:text-blue-100 mb-2">Tarifa Detalle Seleccionada</div>
          <div class="grid grid-cols-2 gap-2 text-xs text-gray-900 dark:text-gray-100">
            <div><span class="font-medium">ID:</span> {{ selectedTrace.match.selectedDetalle?.id || '-' }}</div>
            <div><span class="font-medium">Prioridad:</span> {{ selectedTrace.match.selectedDetalle?.prioridad ?? '-' }}</div>
            <div><span class="font-medium">Unidad:</span> {{ selectedTrace.match.selectedDetalle?.unidadTarifacion || '-' }}</div>
            <div><span class="font-medium">Precio:</span> {{ selectedTrace.match.selectedDetalle?.precioUnitario ?? 0 | number:'1.2-2' }}</div>
            <div><span class="font-medium">Especificidad:</span> {{ selectedTrace.match.selectedDetalle?.specificity ?? '-' }}</div>
            <div><span class="font-medium">Rank:</span> #{{ selectedTrace.match.selectedDetalle?.rank ?? '-' }}</div>
          </div>
          
          <!-- Razones de selección -->
          <div class="mt-2 text-xs">
            <div class="font-medium text-blue-900 dark:text-blue-200">Razón de selección:</div>
            <div class="text-blue-700 dark:text-blue-300">
              @if (selectedTrace.match.selectedDetalle?.rank === 1) {
                <div class="flex items-center gap-1">
                  <span class="text-green-600 dark:text-green-400">✓</span>
                  <span>Seleccionada por tener la mayor prioridad y especificidad entre los candidatos válidos</span>
                </div>
              } @else {
                <div class="flex items-center gap-1">
                  <span class="text-yellow-600 dark:text-yellow-400">⚠</span>
                  <span>Seleccionada como candidato #{{ selectedTrace.match.selectedDetalle?.rank }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      }
      
      <!-- Cálculo -->
      @if (selectedTrace.calculation) {
        <div class="mb-3 p-2 bg-gray-50 dark:bg-gray-800/50 rounded border border-gray-200 dark:border-gray-700/50">
          <div class="text-xs font-semibold mb-2 text-gray-900 dark:text-gray-100">Cálculo</div>
          <div class="text-xs space-y-1 text-gray-800 dark:text-gray-200">
            <div><span class="font-medium">Cantidad facturable:</span> {{ selectedTrace.calculation.billingQty ?? '-' }}</div>
            <div><span class="font-medium">Factor:</span> {{ selectedTrace.calculation.factor ?? '-' }}</div>
            @if (selectedTrace.calculation.formula) {
              <div class="mt-1"><span class="font-medium">Fórmula:</span> {{ selectedTrace.calculation.formula }}</div>
            }
            <div class="mt-1 font-semibold">
              <span class="font-medium">Subtotal:</span> $ {{ selectedTrace.calculation.subtotalPreview | number:'1.2-2' }}
            </div>
            @if (selectedTrace.calculation.bonificado) {
              <div class="text-orange-600 dark:text-orange-400 font-medium">⚠ Ítem bonificado</div>
            }
          </div>
        </div>
      }
      
      <!-- Candidatos alternativos (solo los primeros 3) -->
      @if (selectedTrace.match.candidates && selectedTrace.match.candidates.length > 1) {
        <div class="mb-3">
          <div class="text-xs font-semibold mb-2 text-gray-900 dark:text-gray-100">Otros candidatos válidos ({{ selectedTrace.match.candidates.length - 1 }})</div>
          <div class="mt-1 flex flex-col gap-1 text-xs">
            @for (candidate of selectedTrace.match.candidates.slice(1, 4); track candidate.id) {
              <div class="p-1 bg-gray-50 dark:bg-gray-800/50 rounded border border-gray-200 dark:border-gray-700/30">
                <div class="flex items-center justify-between text-gray-900 dark:text-gray-100">
                  <span class="font-medium">#{{ candidate.rank }} ID {{ candidate.id ?? '-' }}</span>
                  <span class="text-gray-600 dark:text-gray-400">Prio {{ candidate.prioridad ?? '-' }} · Esp {{ candidate.specificity ?? '-' }}</span>
                </div>
                @if (candidate.rank && candidate.rank > 1) {
                  <div class="text-gray-600 dark:text-gray-400 text-xs mt-0.5">
                    No seleccionada: 
                    @if ((selectedTrace.match.selectedDetalle?.prioridad ?? 0) > (candidate.prioridad ?? 0)) {
                      prioridad menor
                    } @else if ((selectedTrace.match.selectedDetalle?.specificity ?? 0) > (candidate.specificity ?? 0)) {
                      especificidad menor
                    } @else {
                      ID mayor
                    }
                  </div>
                }
              </div>
            }
            @if (selectedTrace.match.candidates.length > 4) {
              <div class="text-xs text-gray-600 dark:text-gray-400 italic">
                ... y {{ selectedTrace.match.candidates.length - 4 }} candidato(s) más
              </div>
            }
          </div>
        </div>
      }
      
      <!-- Mensaje de estado -->
      @if (selectedTrace.message) {
        <div class="mt-2 p-2 bg-yellow-50 dark:bg-yellow-900/30 rounded border border-yellow-200 dark:border-yellow-700/50 text-xs text-yellow-800 dark:text-yellow-200">
          {{ selectedTrace.message }}
        </div>
      }
      
      <!-- Estado -->
      <div class="mt-3 text-xs text-gray-900 dark:text-gray-100">
        <span class="font-medium">Estado:</span>
        <span [class]="{
          'text-green-600 dark:text-green-400': selectedTrace.status === 'MATCHED',
          'text-red-600 dark:text-red-400': selectedTrace.status === 'NO_MATCH',
          'text-yellow-600 dark:text-yellow-400': selectedTrace.status === 'INCOMPLETE',
          'text-orange-600 dark:text-orange-400': selectedTrace.status === 'BONIFICADO'
        }">
          {{ selectedTrace.status }}
        </span>
      </div>
    </div>
  } @else {
    <div class="text-xs text-gray-600 dark:text-gray-400">Sin detalle de cálculo.</div>
  }
</p-dialog>
